<template lang="slm">
  div
    .section.header
      h2 Обьявления
    .section.filters.mt-3
      .container.text-left
        h2 Фильтры
        form.form-inline
          .filter
            label Рубрика
            select.form-control
              option Строительство
          .filter
            label Тип работы
            select.form-control
              option Все
          .filter
            label Зарплата
            input.form-control placeholder='от (грн.)'
            input.form-control placeholder='до'
          .filter
            label Тип занятости
            select.form-control
              option Все
          .filter
            label Удалённая работа
            select.form-control
              option Все
          .filter
            label Собеседование онлайн
            select.form-control
              option Все
    .section.items
      .container
        .item v-for='item in items'
          h2 {{ item.title }}
          h3
            . от
            strong
              . {{ item.salary_from | money }}
            template v-if='item.salary_to'
              . до
              strong
                . {{ item.salary_to | money }}
            . /за месяц
            span.ml-3 v-if='item.salary_by_agreement'
              | Договорная
          span
            . {{ item.address }}
            ==> '&bull;'
            . {{ item.date | relativeDate }}
            ==> '&bull;'
            . {{ item.type1 }}
            ==> '&bull;'
            . {{ item.type2 }}
</template>

<style lang="stylus" scoped>
.section
  &.header
    background-color white
  &.filters
    .filter
      display block
      margin-right 12px
      margin-bottom 12px
      min-width 200px
      > label
        justify-content left
      > select
        width 100%
  &.items
    .item
      display block
      margin-top 12px
      margin-bottom 12px
      padding 12px
      background-color white
      text-align left
      h2
        margin-bottom 32px
</style>

<script>
// import gql from 'graphql-tag';
import dateformat from 'dateformat';

export default {
  name: 'AnnouncementsPage',
  filters: {
    money(value) {
      const valueFloat = parseFloat(`${value}`);
      const valueInt = Math.floor(valueFloat);
      let valueTxt = `${valueInt}`
        .split('')
        .reverse()
        .join('')
        .replace(/(\d{3})/g, '$1 ')
        .split('')
        .reverse()
        .join('');
      if (valueFloat - valueInt > 0) {
        const frac = Math.round((valueFloat - valueInt) * 100);
        valueTxt += `,${frac}`;
      }
      return `${valueTxt} грн.`;
    },
    relativeDate(value) {
      const valueDay = dateformat(value, 'dd.mm.yyyy');
      const today = dateformat(new Date(), 'dd.mm.yyyy');
      let text = '';
      if (valueDay === today) {
        text = 'Сегодня';
      } else {
        text = valueDay;
      }
      text += dateformat(value, ' HH:MM');
      return text;
    },
  },
  data() {
    return {
      items: [{
        title: 'Требуются разнорабочие',
        salary_from: 7500,
        salary_to: 8000,
        address: 'Мариуполь',
        date: new Date(),
        type1: 'Постоянная работа',
        type2: 'Работа на полную ставку',
      }, {
        title: 'Срочно требуется сварщик в цех с опытом работы',
        salary_from: 20000,
        salary_by_agreement: true,
        address: 'Одесса, Малиновский',
        date: new Date(),
        type1: 'Постоянная работа',
        type2: 'Работа на полную ставку',
      }],
    };
  },
};
</script>
